document.addEventListener('DOMContentLoaded', function () {
  function triggerAddToCart(event) {
    event.preventDefault();
    const productFormBtn = document.querySelector('.product-form__buttons');
    if (productFormBtn) {
      productFormBtn.querySelector('.product-form__submit').click();
    }
  }

  function getWishlistSourceButton() {
    return document.querySelector('.fake-buy-butons-wrapper .swishlist-fake > button.wishlist-ready');
  }

  function syncWishlistButtons() {
    const swishlistElem = getWishlistSourceButton();
    const isAdded = swishlistElem && swishlistElem.classList.contains('in-wishlist');
    document.querySelector('.fake-buy-butons-wrapper--clone .swishlist-fake-clone > button').classList.toggle('active', Boolean(isAdded));
  }

  function triggerWishlist(event) {
    event.preventDefault();
    const swishlistElem = getWishlistSourceButton();
    if (swishlistElem) {
      swishlistElem.click();
      window.setTimeout(syncWishlistButtons, 50);
    }
  }

  function bindFakeButtons(scope) {
    const buyBtn = scope.querySelector('#ProductSubmitBtn-fake, #ProductSubmitBtn-fake-sticky');
    if (buyBtn) {
      buyBtn.addEventListener('click', triggerAddToCart);
    }

    if (scope.classList && scope.classList.contains('fake-buy-butons-wrapper--clone')) {
      const wishlistBtn = scope.querySelector('.swishlist-fake-clone > button');
      wishlistBtn && wishlistBtn.addEventListener('click', triggerWishlist);
    }
  }

  bindFakeButtons(document);

  let count = 0;
  let syncFlag = false;
  const timer = setInterval(function () {
    const swishlistElem = getWishlistSourceButton();
    if (swishlistElem) {
      syncWishlistButtons();
      syncFlag = true;
    }

    if (syncFlag || count > 10) {
      clearInterval(timer);
    }
    count++;
  }, 1000);

  const wrapper = document.querySelector('.fake-buy-butons-wrapper');
  if (wrapper) {
    const stickyClone = document.createElement('div');
    stickyClone.classList.add('fake-buy-butons-wrapper--clone');

    const sourceBuyBtn = wrapper.querySelector('#ProductSubmitBtn-fake');
    const stickyCloneBuyBtn = sourceBuyBtn.cloneNode(true);
    if(stickyCloneBuyBtn) {
      stickyCloneBuyBtn.id = 'ProductSubmitBtn-fake-sticky';
    }
    stickyClone.appendChild(stickyCloneBuyBtn);

    const cloneWishlistBtnHtml = `
      <div class="swishlist-fake-clone">
        <button>
        <svg class="wishlist-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="display: inline; fill: none; stroke: currentcolor; stroke-width: 2;">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
        </svg>
        <svg class="wishlist-icon added" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="display: inline; fill: currentcolor; stroke: currentcolor; stroke-width: 2;">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
          </svg>
        </button>
      </div>
    `;
    stickyClone.insertAdjacentHTML('beforeend', cloneWishlistBtnHtml);
    document.body.appendChild(stickyClone);

    bindFakeButtons(stickyClone);

    function getViewportWidth() {
      return window.visualViewport ? window.visualViewport.width : window.innerWidth;
    }

    function syncStickyClone() {
      const sourceBuyBtn = wrapper.querySelector('#ProductSubmitBtn-fake');
      const cloneBuyBtn = stickyClone.querySelector('#ProductSubmitBtn-fake-sticky');

      if (sourceBuyBtn && cloneBuyBtn) {
        cloneBuyBtn.className = sourceBuyBtn.className;
        cloneBuyBtn.innerHTML = sourceBuyBtn.innerHTML;
        if (sourceBuyBtn.hasAttribute('disabled')) {
          cloneBuyBtn.setAttribute('disabled', '');
        } else {
          cloneBuyBtn.removeAttribute('disabled');
        }
      }

      syncWishlistButtons();
    }

    const cloneSyncObserver = new MutationObserver(function () {
      syncStickyClone();
    });

    cloneSyncObserver.observe(wrapper, {
      subtree: true,
      childList: true,
      attributes: true,
      characterData: true
    });

    function setStickyState(shouldStick) {
      if (shouldStick) {
        syncStickyClone();
        document.body.classList.add('buy-buttons-sticky');
        stickyClone.classList.add('is-sticky');
      } else {
        document.body.classList.remove('buy-buttons-sticky');
        stickyClone.classList.remove('is-sticky');
      }
    }

    function updateStickyState(entry) {
      if (getViewportWidth() >= 750) {
        setStickyState(false);
        return;
      }

      const shouldStick = entry ? !entry.isIntersecting : false;

      console.log('shouldStick', shouldStick);
      setStickyState(shouldStick);
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        updateStickyState(entry);
      });
    }, {
      threshold: 0,
      rootMargin: '-100px 0px 0px 0px'
    });

    observer.observe(wrapper);
  }
});